<footer class="h-8 flex justify-between items-center px-3 bg-default">
  <img [ngSrc]="logoUrl" [alt]="'common.altText.mitsubishiLogo' | translate" height="12" priority="true" width="124" />
  <div class="flex justify-center items-center gap-2">
    <span class="text-surface-500 text-xs">
      {{ 'nav.footer.copyright' | translate: { year: currentYear } }}
    </span>
    <a
      [text]="true"
      href="https://www.linkedin.com/company/mitsubishi-motor-sales-of-canada-inc-/posts/?feedView=all"
      pButton
      severity="secondary"
      size="small"
      target="_blank"
      ><i class="pi pi-linkedin"></i
    ></a>
    <a
      [text]="true"
      href="https://www.instagram.com/mitsubishican/"
      pButton
      severity="secondary"
      size="small"
      target="_blank"
      ><i class="pi pi-instagram"></i
    ></a>
  </div>
</footer>
